import types from "./types"
import { APIPost, APIGet } from 'utilities/APIRequestHelper'
import apiURLBuilder from 'core/apiURLBuilder'
import { OFFERS_RENEWAL_LANDING, WEB, CC, OFFICE } from 'constants/index'
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper'


const setLoading = (loading) => ({
    type: types.SET_LOADING,
    payload: loading,
  });
  
const setError = (error) => ({
    type: types.SET_ERROR,
    payload: error,
});

const setData = (data) => ({
    type: types.SET_DATA,
    payload: data,
});
const reset = () => ({
    type: types.RESET,
});

const setOffersSelectedLoading = (loading) => ({
    type: types.SET_LOADING_OFFERS_SELECTED,
    payload: loading,
  });
  
const setOffersSelectedError = (error) => ({
    type: types.SET_ERROR_OFFERS_SELECTED,
    payload: error,
});

const setOffersSelectedData = (data) => ({
    type: types.SET_DATA_OFFERS_SELECTED,
    payload: data,
});

const getChannel = () => {
    if (__CONTACT_CENTER__) {
        return CC
    }
    if (isPrintOfficeMode()) {
        return OFFICE
    }
    return WEB
}

const fetchOffers = () => (dispatch) => {
    dispatch(setLoading(true));
    const offerRequestData = {
        query: {
            'flow': 'DEPOSITS_RENEWAL_LANDING',
            'channel': getChannel()
        },
    };
    return APIPost(dispatch, apiURLBuilder.getURL('offers'), offerRequestData)
        .then(response => {
            dispatch(setData(response));
        })
        .catch(error => {
            dispatch(setError(error))
        })
}

const fetchOffersSelected = (payload = {}) => (dispatch) => {
    dispatch(setOffersSelectedLoading(true));

    const offerRequestData = {
        query: {
            'flow': payload.flow || OFFERS_RENEWAL_LANDING,
            'channel': getChannel(),
            'metadata': {
                'contractNumber': payload.contract
            }
        },
    };

    return APIPost(dispatch, apiURLBuilder.getURL('offers'), offerRequestData)
        .then(response => {
            dispatch(setOffersSelectedData(response));
        })
        .catch(error => {
            dispatch(setOffersSelectedError(error))
        })
        .finally(() => {
            dispatch(setOffersSelectedLoading(false))
        });
}

const fetchOffers2 = (payload = {}) => (dispatch) => {
    dispatch(setLoading(true));
    const offerRequestData = {
        query: {
            'channel': getChannel(),
            ...payload
        },
    };
    return APIPost(dispatch, apiURLBuilder.getURL('offers'), offerRequestData)
        .then(response => {
            dispatch(setData(response || []));
        })
        .catch(error => {
            dispatch(setError(error))
        });
}

export{
    fetchOffers,
    fetchOffersSelected,
    fetchOffers2,
    reset
};
